import PropTypes from 'prop-types';

export const userPropTypes = {
  roleName: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null, undefined])]),
  firstName: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null, undefined])]),
  lastName: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null, undefined])]),
};
